module.exports = __webpack_public_path__ + "img/daylight_5.2ea5533f.png";